/* global __CLIENT__ */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Modal from './CacaAoTesouroModalComponent';
import Sign from './CacaAoTesouroSignComponent';
// Check the documentation (readme.txt) for more information...

const bauFechado = '/imgHunt/bauFechado.png';

class CacaAoTesouroGlobalCheck extends Component {
    constructor(props) {
        super(props);

        this.state = {
            effectsHandler: false,
        };

        this._$ = __CLIENT__ && document.querySelector.bind(document);

        this._handlingEffectsBau = this._handlingEffectsBau.bind(this);
    }

    componentDidMount() {
        // first thing is check is user has reserved prize
        this.props.checkSomeReservedPrize();
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.userWonPremio !== this.props.userWonPremio ||
            nextProps.showModal !== this.props.showModal ||
            nextProps.token !== this.props.token ||
            nextProps.huntAllInfos !== this.props.huntAllInfos ||
            nextProps.hasActiveHunt !== this.props.hasActiveHunt ||
            nextProps.registrationComplete !== this.props.registrationComplete ||
            nextProps.checkedReservedPrize !== this.props.checkedReservedPrize ||
            nextProps.location !== this.props.location ||
            nextProps.showSign !== this.props.showSign;
    }

    componentDidUpdate(prevProps) {
        const { hasActiveHunt, checkedReservedPrize } = this.props;

        // if user is not logged or not has complete register
        // AND not is checked if has active hunt yet
        // continued checking
        if ((!this.props.token || !this.props.registrationComplete) && isNull(hasActiveHunt)) {
            this.props.validateIfHasActiveTesouro();
        }

        // if not  checked by reserved prize yet
        // And user was not logged and now is logged
        if (!checkedReservedPrize && (prevProps.token !== this.props.token)) {
            this.props.checkSomeReservedPrize();
        }

        // If has active hunt
        // AND user change the page
        // and not won prize yet
        if (
            hasActiveHunt && (prevProps.location !== this.props.location)
            && this.props.token && this.props.registrationComplete
            && !this.props.userWonPremio
        ) {
            this.props.setPageViewAndCheckWin(hasActiveHunt);
        }
    }

    _handlingEffectsBau() {
        const $ = this._$;

        if ($('.closedBau')) {
            $('.closedBau').classList.remove('animationBoucenIn');

            $('.closedBau').classList.remove('animationShake');

            setTimeout(() => { $('.closedBau') && $('.closedBau').classList.add('animationShake'); }, 300);
        }
    }

    _workWinner() {
        // change  status "reservado" to "ganhou" and sendMail
        this.props.changeLogStatusAndSendMail();
    }

    render() {
        if (this.props.userWonPremio) {
            // user won something, show the bau
            clearInterval(this.state.effectsHandler);

            this.setState({
                effectsHandler: setInterval(this._handlingEffectsBau, 3000),
            });

            return (
                <div className="bauWin">
                    { /* eslint-disable-next-line react/jsx-no-bind */}
                    <Button title="Clique para abrir o baú" onClick={this._workWinner.bind(this)}>
                        <img className="closedBau animationBoucenIn" src={bauFechado} alt="Báu fechado" />
                    </Button>
                </div>
            );
        }

        if (this.props.showModal) {
            // user clicked on the bau, show the modal
            return (<Modal
                handleModal={this.props.handleModal}
                setShareSituation={this.props.setShareSituation}
                prizeInfo={this.props.showModal}
            />);
        }

        if (this.props.location !== '/caca-ao-tesouro') {
            // if we are not on the caça ao tesouro page show the tesouro sign
            return (<Sign
                checkInfoActiveHunt={this.props.checkInfoActiveHunt}
                huntAllInfos={this.props.huntAllInfos}
                showSign={this.props.showSign}
                setShowSign={this.props.setShowSign}
            />);
        }

        return null;
    }
}

CacaAoTesouroGlobalCheck.propTypes = exact({
    hasActiveHunt: PropTypes.oneOfType([ // <-- it just is called if user is logged, and the objective of the function is find some ACTIVE HUNT  for user logged
        PropTypes.bool, // PS: do not confuse with  "fecthInfoActiveHunt" that get info active hunt independent of user
        PropTypes.object, // you can find de businnes rules in documentation file
    ]),
    userWonPremio: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]),
    location: PropTypes.string,
    checkSomeReservedPrize: PropTypes.func,
    validateIfHasActiveTesouro: PropTypes.func,
    setPageViewAndCheckWin: PropTypes.func,
    changeLogStatusAndSendMail: PropTypes.func,
    token: PropTypes.string,
    registrationComplete: PropTypes.bool,
    checkedReservedPrize: PropTypes.bool,
    showModal: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]),
    handleModal: PropTypes.func,
    setShareSituation: PropTypes.func,
    checkInfoActiveHunt: PropTypes.func, // Get active hunt , independent if user is logged or not (it's  in using by sign component)
    huntAllInfos: PropTypes.object,
    showSign: PropTypes.bool,
    setShowSign: PropTypes.func,
});


export default CacaAoTesouroGlobalCheck;
